import React from "react";
import CardItem from '../CardItem';
import lozad from 'lozad';
import { useEffect } from "react";

const observer = lozad();
observer.observe();

function Edited_Images() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);
    return(
        <>

      <style>
        {`
          @media only screen and (max-width: 1024px) {
            .cards__item {
              margin-bottom: 2rem;
              width: 100%;
              margin-left: -13px;
            }
          }
        `}
      </style>
            <ul className='cards__items'>
            <CardItem
              class="lozad"
              src='images/photo_editing/PE3.png'
              text='Change the background of an image.'
              label='Photoshop'
            />
            <CardItem
              class="lozad"
              src='images/photo_editing/car.avif'
              text='Capture RC. Car picture and add the background to make it realistic.'
              label='Photoshop'
            />
            <CardItem
              class="lozad"
              src='images/photo_editing/pb.jpg'
              text='I capture my own picture at home and its my first lightroom work.'
              label='Lightroom'
            />
           
          </ul>

          <ul className='cards__items'>
            <CardItem
              class="lozad"
              src='images/photo_editing/PE6.png'
              text='Change the background and add the shadow to make it look real.'
              label='Photoshop'
            />
            <CardItem
              class="lozad"
              src='images/photo_editing/PE7.png'
              text='Change the background of an image.'
              label='Photoshop'
            />
            <CardItem
              class="lozad"
              src='images/photo_editing/pedit.jpg'
              text='Remove some garbage and I added iron fences and try to make the ground clear.'
              label='Photoshop'
            />
           
          </ul>


          <ul className='cards__items'>
            <CardItem
              class="lozad"
              src='images/photo_editing/jaipur.avif'
              text='Change the sky by combining cloudy image with the picture captured by me.'
              label='Lightroom'
            />
            <CardItem
              class="lozad"
              src='images/photo_editing/JLN.avif'
              text='Change the sky by combining cloudy image with the picture captured by me.'
              label='Lightroom'
            />
            <CardItem
              class="lozad"
              src='images/photo_editing/jalmahal.avif'
              text='I capture this pic and used lightroom, I edited this while learning lightroom.'
              label='Lightroom'
            />
           
          </ul>

          <iframe src="https://drive.google.com/file/d/14R3Uz2l1dFBTObmsJCd9Tqiz3XwlN2oh/preview" width="50%" height="480" allow="autoplay"></iframe>
        </>
    );
}

export default Edited_Images;